{
	"placeholder": "Search materials, notes, flashcards, quizzes…",
	"empty": {
		"initial": "Type a query or pick an action",
		"noResults": "Nothing found",
		"hint": "Try different words or pick an action below"
	},
	"groups": {
		"recents": "Recent",
		"topics": "Course topics",
		"materials": "Materials",
		"notes": "Notes",
		"flashcards": "Flashcards",
		"quizzes": "Quizzes",
		"chats": "Chats",
		"actions": "Actions"
	},
	"actions": {
		"ask": "Ask the tutor",
		"askWith": "Ask the tutor: \"{query}\"",
		"uploadMaterial": "Upload material",
		"startRecording": "Start lecture recording",
		"newNote": "New note",
		"openSettings": "Settings",
		"toggleTheme": "Toggle theme",
		"openSearch": "Open full search",
		"webSearch": "Search the web"
	},
	"preview": {
		"hint": "Hover a result to see its preview here"
	},
	"hints": {
		"navigate": "navigate",
		"select": "open",
		"close": "close",
		"clearRecents": "Clear recent searches"
	},
	"loading": "Searching…",
	"error": {
		"title": "Search failed",
		"retry": "Retry"
	}
}
